import React, { useEffect } from 'react';
import { OptimizelyProvider, createInstance } from '@optimizely/react-sdk';
/**
 * App-level wrapper to provide access to Optimizely's APIs.
 * Passing the user ID allows us to get the experiment variation
 * based on configuration in Optimizely.
 * @packageDocumentation
 */

declare global {
  interface Window {
    optimizelyClientInstance: any;
  }
}

interface GuildOptimizelyProviderProps {}

export const GuildOptimizelyProvider: React.FC<GuildOptimizelyProviderProps> = ({ children }) => {
  const optimizelyClientInstance = createInstance({
    sdkKey: process.env.REACT_APP_OPTIMIZELY_SDK_KEY,
    eventBatchSize: 10,
    eventFlushInterval: 1000,
    datafileOptions: {
      // proxy the request through Guild domains to prevent ad blocker and firewall issues
      urlTemplate: `${process.env.REACT_APP_OPTIMIZELY_BASE_URL}/optimizelydatafile=%s.json`,
    },
  });

  useEffect(() => {
    // set 'optimizelyClientInstance' on the window for Segment integration
    if (!window.optimizelyClientInstance) {
      window.optimizelyClientInstance = optimizelyClientInstance;
    }
  }, [optimizelyClientInstance]);

  return (
    <OptimizelyProvider optimizely={optimizelyClientInstance} timeout={1000} user={{ id: ' ' }}>
      {children}
    </OptimizelyProvider>
  );
};

export default GuildOptimizelyProvider;
